import Vue from 'vue'
import Router from 'vue-router'
import Device from '@/components/device'
import Module from '@/components/module'
import DeviceDetail from '@/components/device-detail'
import DeviceMonitor from '@/components/device-monitor'
import DevicePic from '@/components/device-pic'
import Login from '@/components/login'
import HistoryData from '@/components/history-data'
import WechatLogin from '@/components/wechat-login'
import WechatRegister from '@/components/wechat-register'
import BindUser from '@/components/bind-user'
import store from '@/store'

Vue.use(Router)
const routes =
  [
    {
      path: '/',
      name: 'login',
      component: Login,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/device',
      name: 'Device',
      component: Device,
      meta: {
        title: '设备列表'
      }
    },
    {
      path: '/module/:id',
      name: 'Module',
      component: Module,
      meta: {
        title: '模块列表'
      }
    },
    {
      path: '/deviceDetail/:id',
      name: 'deviceDetail',
      component: DeviceDetail,
      meta: {
        title: '设备详情'
      }
    },
    {
      path: '/deviceMonitor/:id',
      name: 'deviceMonitor',
      component: DeviceMonitor,
      meta: {
        title: '设备监控'
      }
    },
    {
      path: '/devicePic/:id',
      name: 'devicePic',
      component: DevicePic,
      meta: {
        title: '设备图'
      }
    },
    {
      path: '/historyData',
      name: 'HistoryData',
      component: HistoryData,
      meta: {
        title: '历史查询'
      }
    },
    {
      path: '/wechatLogin',
      name: 'WechatLogin',
      component: WechatLogin,
      meta: {
        title: '微信登陆'
      }
    },
    {
      path: '/register',
      name: 'WechatRegister',
      component: WechatRegister,
      meta: {
        title: '微信注册'
      }
    },
    {
      path: '/bindUser',
      name: 'BindUser',
      component: BindUser,
      meta: {
        title: '微信绑定'
      }
    }
  ]
// 路由配置
const router = new Router({
  mode: 'history',
  routes
})
router.afterEach((to) => {
  document.title = to.meta.title
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js